import React from "react";

// Geometric interlocking "S" mark — two concrete blocks with an orange angular accent.
export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
         xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M8 12 L28 12 L34 6 L40 12 L20 12 Z" fill="#FF5A00" />
      <path d="M8 14 L30 14 L30 24 L16 24 L16 27 L34 27 L34 42 L8 42 L8 32 L22 32 L22 29 L8 29 Z"
            fill="#1A2433" stroke="#0D131B" strokeWidth="0.5" />
      <path d="M8 14 L30 14 L30 24 L16 24 L16 27 L8 27 Z" fill="#2A3648" />
    </svg>
  );
}

export function Logo({ dark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoMark size={30} />
      <span className={`font-bold text-xl tracking-tight ${dark ? "text-white" : "text-sp-navy"}`}>
        sitepar<span className="text-sp-orange">.</span>
        <span className={dark ? "text-white/70" : "text-sp-concrete"}>com</span>
      </span>
    </div>
  );
}
